import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QueueMessage } from "../typeDefs/queueManagement";
import { ExistingSymbol, SymbolsXref } from "../typeDefs/iex";

export interface IexState {
    symbols: ExistingSymbol[];
    tenants: SymbolsXref[];
    customers: SymbolsXref[];
    loading: boolean;
    logs: QueueMessage[];
    mostRecentRun: Date | null;
}

const initialState: IexState = {
    symbols: [],
    tenants: [],
    customers: [],
    loading: false,
    logs: [],
    mostRecentRun: null,
};

export const iexSlice = createSlice({
    name: "iex",
    initialState,
    reducers: {
        setSymbols: (state, action: PayloadAction<ExistingSymbol[]>) => {
            state.symbols = action.payload;
        },
        setTenants: (state, action: PayloadAction<SymbolsXref[]>) => {
            state.tenants = action.payload;
        },
        setCustomers: (state, action: PayloadAction<SymbolsXref[]>) => {
            state.customers = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMessages: (state, action: PayloadAction<QueueMessage[]>) => {
            state.logs = action.payload;
        },
        setMostRecentRun: (state, action: PayloadAction<Date | null>) => {
            state.mostRecentRun = action.payload;
        },
    },
});

export const {
    setSymbols,
    setTenants,
    setCustomers,
    setLoading,
    setMessages,
    setMostRecentRun,
} = iexSlice.actions;

export default iexSlice.reducer;
